'use client';
import { StateCreator } from 'zustand/index';
import { CalendarStore } from '@/hooks/use-calendar-store';
import { PrintSettingsState } from '@/types/print-settings';

export type PrintSettingsStore = {
  printSettings: PrintSettingsState;
  togglePrintSetting: (key: keyof PrintSettingsState) => void;
  setPrintSetting: (key: keyof PrintSettingsState, value: boolean) => void;
};

export const initialPrintSettings: PrintSettingsState = {
  printWithActiveFilters: true,
  printDoubleBookings: false,
  showTradeBadge: false,
  showCategoryLabels: false,
  printOnlyProjects: false,
};

export const createPrintSettingsSlice: StateCreator<Partial<CalendarStore> & PrintSettingsStore> = (set) => ({
  printSettings: initialPrintSettings,
  setPrintSetting: (key: keyof PrintSettingsState, value: boolean) => {
    set((state) => {
      const newPrintSettings = {
        ...state.printSettings,
        [key]: value,
      };

      return {
        ...state,
        printSettings: newPrintSettings,
      };
    });
  },
  togglePrintSetting: (key: keyof PrintSettingsState) => {
    set((state) => {
      const newPrintSettings = {
        ...state.printSettings,
        [key]: !state.printSettings[key],
      };

      return {
        ...state,
        printSettings: newPrintSettings,
      };
    });
  },
});

